import _ from 'lodash'
import query from '../query'

export default (cache, { data: { duplicateAction } }) => {
  let prev

  try {
    prev = cache.readQuery({ query })
  } catch (e) {}

  if (!prev) return

  const { actions } = prev

  cache.writeQuery({
    query,
    data: { actions: _.concat(actions, duplicateAction) },
  })
}
